export default __webpack_public_path__ + "static/media/exhibitor.d66bca9e.png";